import { TeamMemberChangedFieldName } from '@/modules/common/types/dto/response/team-member-changed-field-response';

/**
 * Field names that should not be displayed in state change indicators.
 * These fields (rates and currency) are hidden from the timeline UI.
 */
export const HIDDEN_STATE_CHANGE_FIELDS = [
  TeamMemberChangedFieldName.INTERNAL_RATE,
  TeamMemberChangedFieldName.EXTERNAL_RATE,
  TeamMemberChangedFieldName.CURRENCY,
];
